<script setup>
const props = defineProps({
  value: [String, Number],
  disabled: Boolean,
  label: String
})
</script>
<template>
  <option :value="props.value" :disabled="props.disabled">
    <slot>{{ label ?? String(props.value) }}</slot>
  </option>
</template>
